import Vue from 'vue'
import Router from 'vue-router'
import ChapterSearch from '@/components/ChapterSearch'
import PrivacyPolicy from '@/components/PrivacyPolicy'
import LegalDisclaimer from '@/components/LegalDisclaimer'
import CookiePolicy from '@/components/Cookies'
import DevWork from '@/components/DevWork'
//  const Bar = { template: '<div>bar</div>' }

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/ChapterSearch',
      name: 'ChapterSearch',
      component: ChapterSearch
    },
    {
      path: '/',
      name: 'DevWork',
      component: DevWork
    },
    {
      path: '/privacypolicy',
      name: 'PrivacyPolicy',
      component: PrivacyPolicy
    },
    {
      path: '/legaldisclaimer',
      name: 'LegalDisclaimer',
      component: LegalDisclaimer
    },
    {
      path: '/cookiepolicy',
      name: 'CookiePolicy',
      component: CookiePolicy
    }
  ]
})
